import React from "react";

function Map() {
  return (
    <div className="google-map">
      <iframe
        id="gmap_canvas"
        title="Google Map of United States"
        src="https://maps.google.com/maps?q=United States&t=&z=11&ie=UTF8&iwloc=&output=embed"
      ></iframe>
    </div>
  );
}

export default Map;
